import React from 'react';
import { useTranslation } from 'react-i18next'; // Import hook i18n

const UniversityPartners: React.FC = () => {
    const { t } = useTranslation('public'); // Gunakan namespace 'public'

    const universities = [
        {
            name: "Universitas Pendidikan Ganesha",
            image: "/logo/logo_undiksha.png",
        },
        {
            name: "Universitas Negeri Surabaya",
            image: "/logo/logo_unesa.png",
        },
        {
            name: "Universitas Negeri Malang",
            image: "/logo/logo_um.png",
        },
        {
            name: "Universitas Negeri Yogyakarta",
            image: "/logo/logo_uny.png",
        },
        {
            name: "Universitas Negeri Semarang",
            image: "/logo/logo_unnes.png",
        },
        {
            name: "Universitas Negeri Jakarta",
            image: "/logo/logo_unj.png",
        },
        {
            name: "Universitas Pendidikan Indonesia",
            image: "/logo/logo_upi.png",
        },
        {
            name: "Universitas Negeri Padang",
            image: "/logo/logo_unp.png",
        },
        {
            name: "Universitas Negeri Medan",
            image: "/logo/logo_unimed.png",
        },
        {
            name: "Universitas Negeri Gorontalo",
            image: "/logo/logo_ung.png",
        },
        {
            name: "Universitas Negeri Manado",
            image: "/logo/logo_unima.png",
        },
        {
            name: "Universitas Negeri Makassar",
            image: "/logo/logo_unm.png",
        },
    ];

    return (
        <section id="university-partners" className="py-12 bg-muted/30">
            <div className="container mx-auto px-4">
                <div className="text-center mb-8">
                    {/* Menggunakan translasi untuk Judul */}
                    <h3 className="text-2xl font-bold text-foreground mb-4">
                        {t('partners.title')}
                    </h3>
                    {/* Menggunakan translasi untuk Subtitle */}
                    <p className="text-muted-foreground">
                        {t('partners.subtitle')}
                    </p>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 items-center justify-items-center">
                    {universities.map((university, index) => (
                        <div key={index} className="flex flex-col items-center space-y-2">
                            <div className="w-19 h-19 bg-white rounded-full shadow-md flex items-center justify-center border">
                                <img
                                    src={university.image || `/generic-logo.png?key=x00du&height=60&width=60&query=logo ${university.name}`}
                                    alt={`Logo ${university.name}`}
                                    className="w-15 h-15 object-contain"
                                />
                            </div>
                            <p className="text-xs text-center text-muted-foreground font-medium max-w-30">
                                {university.name}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default UniversityPartners;